/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ExchangeCurrencyRate {
    getFixupPrototypeFunction() { return ExchangeCurrencyRate.fixupPrototype; }

    static newInstance(model: Partial<ExchangeCurrencyRate>): ExchangeCurrencyRate {
        let obj = Object.assign(new ExchangeCurrencyRate(), model);
        ExchangeCurrencyRate.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ExchangeCurrencyRate>): ExchangeCurrencyRate {
        if (!model) return null;
        return ExchangeCurrencyRate.newInstance(<ExchangeCurrencyRate> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ExchangeCurrencyRate) {
        if (!obj) return;

        models.ExchangeCurrencyRate.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ExchangeCurrencyRate): boolean {
        Object.setPrototypeOf(obj, ExchangeCurrencyRate.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.exchange_rate === undefined) {
            this.exchange_rate = 0;
        }
    }

    /**
     * Source Currency for Exchange Configuration
     */
    source_currency: models.Currency;

    /**
     * Exchange Rate of Currency Exchange Configuration
     */
    exchange_rate: number;

}
